var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMotif32(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 16.0001,
    height: 15.9953,
    viewBox: "0 0 16.0001 15.9953",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 177"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16 7.99767C16 3.58072 12.4182 0 8 0C3.58176 0 0 3.58072 0 7.99767C0 12.4146 3.58176 15.9953 8 15.9953H16V7.99767Z",
    fill: "#508FCC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.0001 11.8584C16.0001 9.57382 14.1475 7.72175 11.8621 7.72175C9.57682 7.72175 7.72421 9.57382 7.72421 11.8584C7.72421 14.1431 9.57682 15.9952 11.8621 15.9952H16.0001V11.8584Z",
    fill: "#E0D65F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotif32);
export default __webpack_public_path__ + "static/media/motif-32.4b4a07d4862590eca4256e54ae46584a.svg";
export { ForwardRef as ReactComponent };